module.exports = __webpack_public_path__ + "static/morkoth-b9c383f7f28f09da48b2e61f5ba09392.jpeg";